import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import DialogInput from 'screens/components/advanced/DialogInput';
import CustomButton from 'screens/components/basic/Button';
import DialogHeader from 'screens/components/basic/DialogHeader'
import { getSellableProducts } from 'actions/EntityActions';
import DecimalInput from 'screens/components/basic/DecimalInput';
import NumberInput from 'screens/components/basic/NumberInput';
import { formInput, clearFormInput } from 'actions/FormActions';
import TextInput from 'screens/components/basic/TextInput';
import { Button } from '@mui/material';

const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};
class POSAccessorySaleDialog extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialog: true
        };
        this.dialogContentRef = React.createRef();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.open && newProps.open !== this.props.open) {
            this.search();
        }
    }

    search = () => {
        const filters = {
            page: 1,
            itemsPerPage: 1,
            searchText: "Generic Accessory Product",
            baseCategoryId: "3",
            categoryId: null,
            branchId: this.props.branchId,
            THC_MIN: 0,
            THC_MAX: 100,
            CBD_MIN: 0,
            CBD_MAX: 100,
            SubCategoryId: [],
            Weight: []
        };

        this.props.getProducts(filters);
    }

    handleKeyPress = (event) => {
        const p = this.props;
        const productFound = p.sellableProducts && p.sellableProducts.filter(p => p.name == "Generic Accessory Product").length > 0 ? p.sellableProducts.filter(p => p.name == "Generic Accessory Product")[0] : null;
        if (event.key === 'Enter') {
           this.confirm(productFound ? productFound.id : 0);
        }
    };

    confirm = (productId) => {
        let p = this.props;
        const verifyProductId = productId && productId > 0;
        const verifyQuantity = p.variableAccessoryQuantity && +p.variableAccessoryQuantity > 0;
        const verifyPrice = p.variableAccessoryPrice && p.variableAccessoryPrice > 0;
        const verifyName = p.variableAccessoryName;
        
        if (verifyProductId && verifyQuantity && verifyPrice && verifyName) {
            p.addProductToPOSOder({
                id: 0,
                productId,
                quantity: +p.variableAccessoryQuantity,
                isManuallyInputted: true,
                packageReference: "",
                isCannabis: false,
                price: (p.variableAccessoryPrice * (p.variableAccessoryQuantity))
                .toFixed(this.props.allowDecimalUnitEnable ? 3 : 2),
                notes: p.variableAccessoryName
            });
        } else {
            alert(this.props.t('pos.accessorySaleDialog.fillingWarning'));
        }
        this.props.clearFormInput(`variableAccessoryPrice`);
        this.props.clearFormInput(`variableAccessoryName`);
        this.props.clearFormInput(`variableAccessoryQuantity`);
        p.onClose();
    }

    render() {
        const { t } = this.props;
        const p = this.props;
        const productFound = p.sellableProducts && p.sellableProducts.filter(p => p.name == "Generic Accessory Product").length > 0 ? p.sellableProducts.filter(p => p.name == "Generic Accessory Product")[0] : null;

        return (
            <DialogInput
                title={<DialogHeader text={t('pos.accessorySaleDialog.addGenericAccessory')} />}
                ref={this.dialogContentRef}
                onKeyDown={this.handleKeyPress}
                modal={true}
                open={p.open && this.state.dialog}
                autoScrollBodyContent={true}
                style={{ zIndex: '980' }}
                actions={[
                    <CustomButton
                        key={1}
                        type="CancelButton"
                        name="buttonClose"
                        className="btn-space"
                        label={t('common.close')}
                        onTouchTap={() => this.props.onClose()} />,
                    <Button
                        key={2}
                        className="pull-right space btnNewBrandPOS"
                        name="buttonRefundDialogConfirm"
                        id="confirmGenericAccessory"
                        variant='contained'
                        onClick={() => this.confirm(productFound ? productFound.id : 0)}>{t('common.confirmUpper')}</Button>]}
                contentStyle={dialogStyle}>
                <div className="row">
                    <div className="col-lg-12">
                        {
                            productFound ?
                                <div>
                                    <p className="alert alert-warning">
                                        {t('pos.accessorySaleDialog.addToOrderInstruction')} <br /> <br />
                                        {t('pos.accessorySaleDialog.addMoreWarning')}
                                    </p>
                                    <div className="col-lg-12">
                                        <TextInput 
                                            name="variableAccessoryName"
                                            fullWidth={true}
                                            label={t('pos.accessorySaleDialog.productName')}
                                            floatingLabelText={t('pos.accessorySaleDialog.productName')}
                                            hintText={t('pos.accessorySaleDialog.productName')} />
                                    </div>
                                    <div className="col-lg-12">
                                        <DecimalInput name={`variableAccessoryPrice`}
                                            fullWidth={true}
                                            label={t('pos.accessorySaleDialog.unitPriceBeforeTax')}
                                            floatingLabelText={t('pos.accessorySaleDialog.unitPriceBeforeTax')}
                                            hintText={t('pos.accessorySaleDialog.unitPriceBeforeTax')}
                                            allowDecimalUnitEnable={this.props.allowDecimalUnitEnable} // Pass this setting
                                        />
                                    </div>
                                    <div className="col-lg-12">
                                        <TextInput
                                            name={`variableAccessoryQuantity`}
                                            fullWidth={true}
                                            label={t('pos.accessorySaleDialog.quantity')}
                                            floatingLabelText={t('pos.accessorySaleDialog.quantity')}
                                            hintText={t('pos.accessorySaleDialog.quantity')}
                                            allowDecimalUnitEnable={this.props.allowDecimalUnitEnable} // Pass this setting
                                        />
                                    </div>
                                </div>
                                :
                                <p className="alert alert-warning">
                                    {t('pos.accessorySaleDialog.productNotFound')}
                                </p>
                        }
                    </div>
                </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        sellableProducts: state.entity.sellableProducts || [],
        variableAccessoryPrice: +state.form.variableAccessoryPrice,
        variableAccessoryQuantity: state.form.variableAccessoryQuantity || 1,
        variableAccessoryName: state.form.variableAccessoryName || "",
        allowDecimalUnitEnable: state.common.applicationSettings.allowDecimalUnitEnable
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getProducts: (filters) => dispatch(getSellableProducts(filters)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        clearFormInput: (name) => dispatch(clearFormInput(name))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSAccessorySaleDialog));
